import React from 'react';
import { Building, Target, Users, Award } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">Hakkımızda</h1>
          <p className="text-xl text-teal-50">Yeni nesil yatırım platformu</p>
        </div>
      </section>

      {/* Company Info */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">CLND Menkul Değerler</h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              CLND Menkul Değerler A.Ş., yatırımcılarına en iyi hizmeti sunmak için güçlü teknoloji altyapısı ve uzman kadrosuyla çalışan, SPK lisanslı bir aracı kurumdur. Modern ve kullanıcı dostu platformlarımız ile yatırım dünyasında yeni bir çağ başlatıyoruz.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed">
              Müşteri memnuniyetini ön planda tutan anlayışımız, şeffaf ve güvenilir hizmet politikamız ile sektörde fark yaratıyoruz. Gelişmiş teknoloji altyapımız sayesinde, yatırımcılarımıza hızlı, güvenli ve kesintisiz işlem imkanı sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Değerlerimiz</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Building className="text-teal-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Güven</h3>
              <p className="text-gray-600">SPK lisanslı ve regülasyonlara tam uyumlu</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Target className="text-teal-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Şeffaflık</h3>
              <p className="text-gray-600">Açık ve net fiyatlama politikası</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="text-teal-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Müşteri Odaklılık</h3>
              <p className="text-gray-600">7/24 müşteri destek hizmeti</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="text-teal-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Kalite</h3>
              <p className="text-gray-600">En yüksek hizmet standartları</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Misyonumuz</h2>
              <p className="text-gray-600 leading-relaxed">
                Yatırımcılarımıza güvenli, hızlı ve kullanıcı dostu bir platform sunarak finansal hedeflerine ulaşmalarına yardımcı olmak. Teknoloji ve uzmanlığı bir araya getirerek, herkes için erişilebilir yatırım deneyimi sağlamak.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Vizyonumuz</h2>
              <p className="text-gray-600 leading-relaxed">
                Türkiye'nin en yenilikçi ve tercih edilen aracı kurumu olmak. Sürekli gelişen teknolojimiz ve müşteri odaklı hizmet anlayışımızla sektöre yön veren lider bir kurum olmak.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
